import { PriceButton } from "./PriceButton";
import { Button } from "./ui/button";
import { useState, useEffect } from "react";

type RecurringSectionProps = {
  selectedPrice: number | null;
  initialPrice: number | null;
  isLoading: boolean;
  isUpdating: boolean;
  fetchError: Error | null;
  onUpdateSubscription: (price: number) => Promise<void>;
};

export function RecurringSection({
  selectedPrice: initialSelectedPrice,
  initialPrice,
  isLoading,
  isUpdating,
  fetchError,
  onUpdateSubscription
}: RecurringSectionProps) {
  // Local state for price selection
  const [selectedPrice, setSelectedPrice] = useState<number | null>(initialSelectedPrice);
  
  // Update local state when props change
  useEffect(() => {
    setSelectedPrice(initialSelectedPrice);
  }, [initialSelectedPrice]);
  
  const handlePriceSelect = (price: number) => {
    setSelectedPrice((prev) => {
      if (prev === price) {
        return null;
      }
      return price;
    })
  };

  // Button is disabled when selectedPrice equals initialPrice or during updates
  const isConfirmDisabled = selectedPrice === initialPrice || isUpdating;

  const handleConfirm = () => {
    if (selectedPrice === null) {
      onUpdateSubscription(0);
      return;
    }
    onUpdateSubscription(selectedPrice);
  };

  return (
    <>
      {isLoading ? (
        <div className="flex justify-center py-8">
          <div className="animate-spin h-8 w-8 border-4 border-blue border-t-transparent rounded-full" />
        </div>
      ) : (
        <>
          <div className='flex flex-row font-medium w-full justify-between mb-4'>
            <span>Set recurring entries (charged Friday)</span>
          </div>
          <div className='space-y-2'>
            <div className='grid grid-cols-4 gap-2 w-full'>
                <PriceButton 
                    price={15} 
                    isSelected={selectedPrice === 15} 
                    onClick={() => handlePriceSelect(15)} 
                />
                <PriceButton 
                    price={30} 
                    isSelected={selectedPrice === 30} 
                    onClick={() => handlePriceSelect(30)} 
                />
                <PriceButton 
                    price={60} 
                    isSelected={selectedPrice === 60} 
                    onClick={() => handlePriceSelect(60)} 
                />
                <PriceButton 
                    price={150} 
                    isSelected={selectedPrice === 150} 
                    onClick={() => handlePriceSelect(150)} 
                />
            </div>
            <Button 
              className="py-6 bg-blue text-white text-2xl font-bold w-full rounded-lg" 
              disabled={isConfirmDisabled}
              onClick={handleConfirm}
            >
              {isUpdating ? 'Updating...' : 'Confirm'}
            </Button>
            
            {fetchError && !fetchError?.message.includes('found') && (
              <p className="text-red-500 text-sm mt-2.5 font-medium">{fetchError.message}</p>
            )}
          </div>
        </>
      )}
    </>
  );
}